import { shallowEqual, useSelector } from 'react-redux';
import dayjs from 'dayjs';

import { RubleSymbol } from '@r1-frontend/ui-react/experimental/purchase/cost/Cost/RubleSymbol';
import { NBSP } from '@r1-frontend/ui-react/tokens/symbols';
import { pluralize } from '@r1-frontend/shared/helpers/pluralize';
import { monthPluralize } from '@r1-frontend/shared/helpers/pluralize/predifined';

import { IHintProps } from '~/src/features/payments-abn/components/InfoHint';
import { selectPaymentSum } from '~/src/features/payments-abn/components/SeasonTicketPayment/store/selectors/selectPaymentSum';
import { ddmmmmyyyy, parseRusDate } from '~/src/helpers/date';
import { toCurrency } from '~/src/helpers/numbers';
import { TState } from '~/src/store';

export const useTicketHint = (): IHintProps => {
    const { wholesaleCheaperData, selectedTicket, currentPaySum } = useSelector((state: TState) => ({
        wholesaleCheaperData: state.wholesaleCheaperData.wholesaleCheaperData,
        selectedTicket: state.seasonTicketPayment.seasonTicket,
        currentPaySum: selectPaymentSum(state),
    }), shallowEqual);

    const { currentFlag = [] } = wholesaleCheaperData || {};
    const { activateDate = '', countMonth = 3 } = selectedTicket || {};

    const sumText = `${toCurrency(currentPaySum)}${NBSP}${RubleSymbol}`;

    if (currentFlag.length) {
        const { closeDate } = currentFlag[currentFlag.length - 1];

        const endDate = ddmmmmyyyy(parseRusDate(closeDate));
        const needPayNewTicket = `Чтобы оформить абонемент, пополните баланс на${NBSP}${sumText}.`;

        return {
            hintType: 'info',
            hintMessage: `У вас уже есть активный абонемент. Новый начнёт действовать, только когда закончится активный — с${NBSP}${endDate}. ${currentPaySum ? needPayNewTicket : ''}`,
        };
    }

    const writeOffPeriodText = `следующие ${countMonth}${NBSP}${pluralize(countMonth, monthPluralize)} мы будем списывать плату за${NBSP}услуги`;
    const needPayText = `Сейчас вы пополните баланс на${NBSP}${sumText}, и${NBSP}${writeOffPeriodText}`;
    const noNeedPayText = `У вас достаточно денег на${NBSP}балансе, поэтому ${writeOffPeriodText} с${NBSP}вашего баланса`;
    const startDate = dayjs(activateDate, 'DD.MM.YYYY').format(`D${NBSP}MMMM`);

    return {
        hintType: 'info',
        hintMessage: `${currentPaySum === 0 ? noNeedPayText : needPayText}. Абонемент будет действовать с${NBSP}${startDate}.`,
    };
};
